import { useContext } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, Modal, ModalContext, Text } from 'dash-ui';

const DeleteSaleTeamModal = ({
  onDeleteSaleTeamClick,
}: {
  onDeleteSaleTeamClick: (index: number) => void;
}) => {
  const theme = useTheme();
  const { t } = useTranslation(['common', 'pages']);
  const { isOpenCurrent, toggleModal, payload, setPayload } =
    useContext(ModalContext);
  const isOpen = isOpenCurrent['DeleteSaleTeamModal'];

  const onRequestClose = () => {
    setPayload(null);
    toggleModal(false, 'DeleteSaleTeamModal');
  };

  const onSubmit = () => {
    onDeleteSaleTeamClick(payload);
    setPayload(null);
    toggleModal(false, 'DeleteSaleTeamModal');
  };

  return (
    <Modal
      title={t('pages:propertyPage.deleteSalesTeam') || ''}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      cancelButton={{
        title: t('common:labels.delete'),
        onClick: onSubmit,
        w: '100%',
        variation: 'primary',
      }}
      submitButton={{
        title: t('common:labels.cancel'),
        onClick: onRequestClose,
        w: '100%',
        variation: 'outline',
      }}
    >
      <Box mt={2}>
        <Text color={theme.colors.n80}>
          {t('pages:propertyPage.deleteSalesTeamText')}
        </Text>
      </Box>
    </Modal>
  );
};

export default DeleteSaleTeamModal;
